import React, { useEffect, useState } from 'react'
import { ToastContext } from '@pdrj/pmi-iqos-ds-react'
import {
  CommonTranslations,
  PublishedComponent,
  TermsPopup as TermsPopupShared,
  getInitialPropsMock,
  parseTranslations,
  getToastMessagesFromError,
  canUseDOM,
  cookie,
  LineInformationPage
} from '@pdrj/pmi-iqos-shared-react'
import { IqosphereApiManager } from '@iqosphere-common/services'
import TermsPopupTranslations from './terms-popup.json'

const TermsPopupComponent = ({ translations, termsContent, line }) => {
  const [showTermsAndCond, setShowTermsAndCond] = useState(true)
  const [termsAndCondLoading, setTermsAndCondLoading] = useState(false)
  const [showLineAcceptedPage, setShowLineAcceptedPage] = useState(false)

  const { popupToast } = ToastContext.getContextActions()

  const api = new IqosphereApiManager(line)
  const tokenInfo = cookie.getTokenInfo()

  useEffect(() => {
    if (line && tokenInfo && tokenInfo.isOptIn) {
      setShowLineAcceptedPage(true)
    }
  }, [])

  const handleCloseLiffPage = () => {
    canUseDOM && window.liff && window.liff.closeWindow()
  }

  const agreedWithNewTermsAndConditions = async () => {
    try {
      setTermsAndCondLoading(true)
      // Get latest T&C verison
      const res = await api.auth.getAuthSettings()
      // Update the profile
      await api.profile.updateProfile({
        data: {
          latestIqosphereTC: res.iqosphereTC
        }
      })
      if (line) {
        canUseDOM && window.liff && window.liff.closeWindow()
      } else {
        setShowTermsAndCond(false)
      }
    } catch (err) {
      popupToast({
        type: ToastContext.types.error,
        subtitle: getToastMessagesFromError(
          err,
          translations.tk_unableToUpdateProfile
        )
      })
    } finally {
      setTermsAndCondLoading(false)
    }
  }

  return line && showLineAcceptedPage ? (
    <LineInformationPage
      translations={translations}
      handleLineGoBack={handleCloseLiffPage}
      blackTheme
    />
  ) : (
    <TermsPopupShared
      isOpen={showTermsAndCond}
      mandatory
      onAccept={agreedWithNewTermsAndConditions}
      termsType={TermsPopupShared.types.iqosphere}
      termsContent={termsContent}
      loading={termsAndCondLoading}
      translations={translations}
    />
  )
}

const TermsPopup = props => {
  return (
    <ToastContext>
      <PublishedComponent
        innerComponent={TermsPopupComponent}
        {...ComponentDefaultProps}
        {...props}
      />
    </ToastContext>
  )
}

const ComponentTranslations = {
  ...TermsPopupTranslations,
  ...CommonTranslations
}

const defaultTranslations = {
  ...parseTranslations(ComponentTranslations, true)
}

const ComponentDefaultProps = {
  componentName: 'TermsPopup',
  translations: defaultTranslations,
  defaultTranslations: defaultTranslations,
  translationsConfig: ComponentTranslations
}

TermsPopup.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    line: !!req?.query?.line,
    componentName: ComponentDefaultProps.componentName,
    defaultTranslations: ComponentDefaultProps.translations,
    translationsConfig: ComponentTranslations,
    getSpecificInitialProps: () => {
      const termsContent =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('termsPopupContent')
          : (req.body.extra && req.body.extra.terms) || null
      return { termsContent }
    }
  })
}

export default TermsPopup
